exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-c35bf5d0] .el-cascader__tags{-ms-flex-wrap:nowrap;flex-wrap:nowrap}[data-v-c35bf5d0] .el-cascader__search-input{cursor:pointer}\n", ""]);

// exports
